module.exports = __webpack_public_path__ + "media/images/new-ui-images/product-tick-094972afa5079b80ce0ba16ec8e11914.svg";